import React from "react";

const Tenants = () => (
  <div className="row work">
    <div className="three columns header-col">
      <h1>
        <span>Tenants</span>
      </h1>
    </div>

    <div className="nine columns main-col">
      <ul class="two-cols">
        <li>Beltone Audiology and Hearing Clinic</li>
        <li>Broadway Family Health Clinic</li>
        <li>Canadian Blood Services</li>
        <li>CNIB</li>
        <li>Curtis Optical</li>
        <li>Derma Electrolysis Clinic</li>
        <li>Health & Performance Centre</li>
        <li>Lawtons Drugs</li>
        <li>Maximum Home Support Services</li>
        <li>Massage Therapy</li>
        <li>Weight Watchers</li>
        <li>Western Memorial Health Clinic</li>
        <li>Western Health Breast Screening</li>
        <li>Western Health Eye Care Centre</li>
      </ul>
    </div>
  </div>
);

export default Tenants;



// WEBPACK FOOTER //
// ./src/components/Tenants.js